import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ChartService } from "../services/ChartService";
import { AudioTrack } from "../components/AudioTrack";
import "../styles/Chart.css";
import { ChevronLeft, Dice5 } from "lucide-react";
import {Toolbar} from "../components/Toolbar";
import { ChartData } from "../types/Types";

export const Chart = () => {
  const { stateNameAlias } = useParams<{ stateNameAlias: string }>();
  const navigate = useNavigate();
  const [chartData, setChartData] = useState<ChartData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      if (stateNameAlias) {
        const data = await ChartService.fetchChartDetailsByAlias(
          stateNameAlias
        );
        setChartData(data);
      }
      setLoading(false);
    };
    loadData();
  }, [stateNameAlias]);

  const handleRandomizeClick = () => {
    if (chartData && chartData.tracks) {
      const shuffled = [...chartData.tracks].sort(() => 0.5 - Math.random());
      setChartData({ ...chartData, tracks: shuffled });
    }
  };

  if (loading) return <div className="chart-loading">Loading...</div>;
  if (!chartData) return <div className="chart-loading">Chart not found.</div>;

  return (
    <div className="chart-page-container">
      <Toolbar />
      <section className="inner-page-layout">
        <section className="inner-page-content">
          <button className="chart-back-btn" onClick={() => navigate(-1)}>
            <ChevronLeft size={20} />
            Back
          </button>

          <div className="chart-banner">
            <h1 className="chart-name">{chartData.stateName}</h1>
            <h2 className="chart-description">TOP 50</h2>
          </div>

          <button
            className="chart-randomize-track-btn"
            onClick={handleRandomizeClick}
          >
            <Dice5 size={18} style={{ marginRight: "8px" }} />
            Randomize
          </button>

          <section className="tracks-container">
            {chartData.tracks?.map((track, index) => (
              <AudioTrack
                key={track.id}
                track={track}
                rank={track.rank || index + 1}
              />
            ))}
          </section>
        </section>
      </section>
    </div>
  );
};
